import { pubsub } from '../components/pubsub.js';

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  dsn: "https://052091aaba794a5182149790d7827c7c@sentry.gameserverkings.com/3",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.01,
});


ready(function() {
  let page_name = document.querySelector("body").dataset.page;
  console.log(page_name);
  pubsub.publish('load-page:' + page_name);
});



// WEBPACK FOOTER //
// ./app/javascript/components_common/page-router.js